import { Link } from "react-router-dom";

export default function BrandSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <Link
            to="/about"
            className="inline-flex items-center px-5 py-2 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            关于樱花动漫
          </Link>

          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light text-foreground-950 leading-tight mt-8 text-balance">
            一站式
            <br />
            免费高清
            <br />
            动漫娱乐平台
          </h2>

          <div className="flex items-center justify-center gap-2 md:gap-3 mt-8">
            <span className="w-8 h-8 md:w-10 md:h-10 rounded-xl bg-primary-50 flex items-center justify-center">
              <i className="ri-play-circle-line text-primary-500 text-lg md:text-xl"></i>
            </span>
            <span className="w-1 h-6 md:h-8 bg-background-200 rounded-full"></span>
            <span className="w-8 h-8 md:w-10 md:h-10 rounded-xl bg-accent-50 flex items-center justify-center">
              <i className="ri-movie-2-line text-accent-500 text-lg md:text-xl"></i>
            </span>
            <span className="w-1 h-6 md:h-8 bg-background-200 rounded-full"></span>
            <span className="w-8 h-8 md:w-10 md:h-10 rounded-xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-heart-line text-secondary-500 text-lg md:text-xl"></i>
            </span>
          </div>

          <p className="text-foreground-600 text-base leading-relaxed mt-8 max-w-xl mx-auto">
            樱花动漫网致力于为广大动漫爱好者提供最优质的在线观看体验。
            我们拥有<strong>超过5000部</strong>动漫、电视剧和电影资源，
            全部<strong>免费高清</strong>无需付费，每日同步更新最新番剧，
            让您随时随地畅享精彩内容。
          </p>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 mt-8 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}